import { Component, OnInit } from '@angular/core';
import { VehicleTypeService } from '../vehicle-type.service'

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpService } from 'src/app/http.service';
import { GlobalService } from 'src/app/global.service';

export interface RelationType {
  id: number;
  name: string;
}
@Component({
  selector: 'app-vehicle-type-register',
  templateUrl: './vehicle-type-register.component.html',
  styleUrls: ['./vehicle-type-register.component.scss']
})
export class VehicleTypeRegisterComponent implements OnInit {

  vehicle_type_register_form: FormGroup;
  action: string = '';
  constructor(private formBuilder: FormBuilder, private vehicleTypeService : VehicleTypeService, private http: HttpService, private global: GlobalService) { 
    this.vehicle_type_register_form = this.formBuilder.group({
      id: [null, Validators.compose([])],
      name: [null, Validators.compose([Validators.required])],
    })

    if (this.vehicleTypeService.get_vehicle_type_data === null) {
      this.action = 'register';
    } else {
      this.action = 'update';
      this.setupUpdateForm(this.vehicleTypeService.get_vehicle_type_data);
    }
    

    this.vehicleTypeService.vehicleTypeUpdate.subscribe((relation_data) => {
      if (relation_data === null) {
        this.action = 'register';
        this.vehicle_type_register_form.reset();
      } else {
        this.action = 'update';
        this.setupUpdateForm(relation_data);
      }
    });
    
    this.vehicleTypeService.vehicleTypeUpdate.subscribe((relation_type) => {
      this.setupUpdateForm(relation_type);
    });
  }

  
  setupUpdateForm(vehicle_type) {
    this.vehicle_type_register_form.controls['id'].setValue(vehicle_type['id']);
    this.vehicle_type_register_form.controls['name'].setValue(vehicle_type['name']);
  }

  registerVehicleType() {
    const vehicle_type = Object.assign({}, this.vehicle_type_register_form.value);
    console.log(vehicle_type)
    this.http.registerVehicleType(vehicle_type).subscribe((data) => {
      this.global.showSnakeBar(data['message']);
      this.vehicleTypeService.downloadVehicleType.emit(true);
    });
  }


  ngOnInit() {
  }

}
